/* Native Shagun: serialized theme reconciliation. Shopify owns discount enforcement. */
(function (window, document) {
  'use strict';
  if (window.ApellaShagun) return;
  var core = window.ApellaGiftCore;
  var queue = window.ApellaCartMutations;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var sectionIds = ['cart-drawer', 'cart-icon-bubble', 'cart-live-region-text', 'main-cart-items', 'main-cart-footer'];
  var storageKey = 'apella-shagun-change';
  var listeners = new Set();
  var cleanup = [];
  var destroyed = false;
  var generation = 0;
  var drain = null;
  var pendingPreferences = {};
  var snapshot = null;
  var requestFailed = false;
  var celebrated = false;
  var renderDirty = false;
  var unpublishedMutation = false;
  var checkoutPending = false;
  var state = { status: 'UPDATING', reason: 'initializing', netPaise: null, remainingRupees: null, gift: null, config: null, cart: null, busy: false, celebrate: false };

  function emit(next) {
    if (destroyed) return;
    state = Object.assign({}, state, next);
    listeners.forEach(function (fn) { try { fn(state); } catch (_) { /* One view must not stop reconciliation. */ } });
  }
  function parseState(html) {
    var node = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-apella-gift-state]');
    if (!node) throw new Error('gift-state-unavailable');
    var value = JSON.parse(node.textContent);
    if (!value || !value.config || !value.cart || !Array.isArray(value.cart.items)) throw new Error('gift-state-invalid');
    return value;
  }
  function remember(value) { snapshot = value; return value; }
  function current(gen) { return !destroyed && gen === generation; }
  function attributes() { return (snapshot && snapshot.cart.attributes) || {}; }
  function preferences() {
    var attrs = attributes();
    return { optedOut: attrs.apella_shagun_opt_out === '1', recoveryRequired: attrs.apella_shagun_recovery === '1' };
  }
  async function request(url, init, onLateSettlement) {
    var controller = new AbortController();
    var timer;
    var timedOut = false;
    var timeout = new Promise(function (_, reject) {
      timer = setTimeout(function () { timedOut = true; controller.abort(); reject(new Error('gift-request-timeout')); }, 10000);
    });
    try {
      var operation = fetch(url, Object.assign({ credentials: 'same-origin', cache: 'no-store', signal: controller.signal }, init)).then(function (response) {
        if (!response.ok) { var error = new Error('gift-request-failed'); error.status = response.status; throw error; }
        return response.json();
      });
      if (onLateSettlement) {
        var settled = function () { if (timedOut && !destroyed) onLateSettlement(); };
        operation.then(settled, settled);
      }
      return await Promise.race([operation, timeout]);
    } finally { clearTimeout(timer); }
  }
  async function fresh() {
    var payload = await request(root + 'cart?sections=apella-cart-gift-status&_shagun=' + Date.now());
    return remember(parseState(payload['apella-cart-gift-status']));
  }
  function sectionTargets() {
    return [
      ['cart-drawer', 'cart-drawer .drawer__inner', '.drawer__inner'],
      ['cart-icon-bubble', '#cart-icon-bubble', '.shopify-section'],
      ['cart-live-region-text', '#cart-live-region-text', '.shopify-section'],
      ['main-cart-items', '#main-cart-items .js-contents', '.js-contents'],
      ['main-cart-footer', '#main-cart-footer .js-contents', '.js-contents']
    ];
  }
  function renderSections(sections, cart) {
    if (!sections || typeof sections !== 'object') return false;
    var valid = true;
    var focused = document.activeElement;
    var focusId = focused && focused.id;
    var selection = focused && typeof focused.selectionStart === 'number' ? [focused.selectionStart, focused.selectionEnd] : null;
    sectionTargets().forEach(function (entry) {
      var target = document.querySelector(entry[1]);
      if (!target) { if (sections[entry[0]] === null) valid = false; return; }
      var html = sections[entry[0]];
      if (typeof html !== 'string' || !html) { valid = false; return; }
      var source = new DOMParser().parseFromString(html, 'text/html').querySelector(entry[2]);
      if (!source) { valid = false; return; }
      // Only same-store section HTML is used here. Never pass this response to
      // product notification/renderContents: those APIs open the drawer.
      target.innerHTML = source.innerHTML;
      if (entry[0] === 'cart-drawer') target.classList.toggle('is-empty', source.classList.contains('is-empty'));
    });
    if (cart && typeof cart.item_count === 'number') {
      ['cart-drawer', '#main-cart-footer', 'cart-items', 'cart-drawer-items'].forEach(function (selector) {
        var element = document.querySelector(selector);
        if (element) element.classList.toggle('is-empty', cart.item_count === 0);
      });
    }
    if (focusId && focused && !focused.isConnected) {
      var replacement = document.getElementById(focusId);
      if (replacement && typeof replacement.focus === 'function') {
        replacement.focus({ preventScroll: true });
        if (selection && typeof replacement.setSelectionRange === 'function') {
          try { replacement.setSelectionRange(selection[0], selection[1]); } catch (_) { /* Non-text input. */ }
        }
      }
    }
    return valid;
  }
  async function post(path, body) {
    return request(root + 'cart/' + path + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }, path === 'add' ? function () {
      // Timeout stops waiting, not necessarily the remote write. Observe any
      // late settlement through a fresh queued read; never retry its ADD.
      renderDirty = true;
      reconcile('add-settled');
    } : null);
  }
  async function persist(patch, result) {
    await post('update', { attributes: patch });
    result.mutated = true;
    unpublishedMutation = true;
    if (snapshot) snapshot.cart.attributes = Object.assign({}, attributes(), patch);
  }
  function decide() { return core.decideGift({ cart: snapshot.cart, config: snapshot.config, preferences: preferences() }); }
  function resultState(decision, busy) {
    var gift = (snapshot.config.gifts || [])[0] || null;
    if (gift && gift.variantId !== decision.selectedVariantId) gift = null;
    return { status: decision.status, reason: decision.reason, netPaise: decision.netPaise, remainingRupees: decision.remainingRupees, gift: gift, config: snapshot.config, cart: snapshot.cart, busy: busy, celebrate: false };
  }
  function recoveryDecision(reason) {
    var decision = snapshot && core ? decide() : { netPaise: null, remainingRupees: null, selectedVariantId: null };
    return Object.assign({}, decision, { status: 'NEEDS_RECOVERY', reason: reason, actions: [] });
  }
  async function transaction(gen) {
    var result = { mutated: false, decision: null, gen: gen };
    var latestSections = null;
    var needsRepair = false;
    try {
      if (!core || !queue) throw new Error('gift-runtime-unavailable');
      await fresh();
      if (!current(gen)) return result;
      var patch = Object.assign({}, pendingPreferences);
      if (Object.keys(patch).length) {
        await persist(patch, result);
        Object.keys(patch).forEach(function (key) { if (pendingPreferences[key] === patch[key]) delete pendingPreferences[key]; });
        await fresh();
      }
      for (var corrections = 0; corrections <= 3; corrections += 1) {
        if (!current(gen)) return result;
        var analysis = core.analyze(snapshot.cart, snapshot.config);
        var decision = decide();
        // A persisted intent precedes ADD. A lost response must never cause a
        // second automatic ADD, even after reload/navigation or in another tab.
        if (attributes().apella_shagun_pending_add) {
          if (preferences().optedOut && !analysis.gifts.length) {
            // Explicit decline is already persisted and this queued read has
            // verified absence. Resolve its pending intent, then read again so
            // a gift arriving during the clear is removed before completion.
            // A later arrival stays declined across tabs/navigation as well.
            await persist({ apella_shagun_pending_add: '' }, result);
            await fresh();
            if (!current(gen)) return result;
            analysis = core.analyze(snapshot.cart, snapshot.config);
            decision = decide();
          } else if (analysis.confirmedGift && analysis.gifts.length === 1 && !preferences().recoveryRequired) {
            await persist({ apella_shagun_pending_add: '' }, result);
          } else if (!analysis.gifts.length) {
            result.decision = recoveryDecision('add-outcome-unknown');
            return result;
          }
        }
        if (decision.reason === 'charged-gift' || decision.reason === 'unverified-gift-discount' || (analysis.gifts.length && analysis.otherDiscount)) {
          if (!preferences().recoveryRequired) await persist({ apella_shagun_recovery: '1' }, result);
          decision = decide();
        }
        if (!decision.actions.length) { result.decision = decision; requestFailed = false; return result; }
        if (corrections === 3) { result.decision = recoveryDecision('correction-limit'); return result; }
        if (!current(gen)) return result;
        var action = decision.actions[0];
        var body = { sections: sectionIds, sections_url: window.location.pathname };
        var response;
        if (action.type === 'ADD') {
          var gift = (snapshot.config.gifts || [])[0];
          var available = gift && gift.variantId === action.variantId && gift.available === true;
          if (!analysis.valid || !available || analysis.gifts.length || analysis.otherDiscount || preferences().optedOut || preferences().recoveryRequired) {
            result.decision = recoveryDecision('add-guard'); return result;
          }
          await persist({ apella_shagun_pending_add: action.variantId }, result);
          if (!current(gen)) {
            // This request was superseded before ADD was sent, so its intent
            // can safely be cancelled rather than marked outcome-unknown.
            await persist({ apella_shagun_pending_add: '' }, result);
            return result;
          }
          body.items = [{ id: action.variantId, quantity: 1, properties: {} }];
          body.items[0].properties[snapshot.config.markerKey || '_apella_shagun'] = snapshot.config.campaignId;
          try { response = await post('add', body); }
          catch (error) {
            renderDirty = true;
            if (error.status === 422) {
              await persist({ apella_shagun_pending_add: '', apella_shagun_recovery: '1' }, result);
              await fresh();
              result.decision = Object.assign(recoveryDecision('gift-unavailable'), { status: 'UNAVAILABLE' });
            } else {
              // Keep pending intent on the cart. Even a subsequent empty read
              // cannot prove that a timed-out request will never complete.
              try { await fresh(); } catch (_) { /* Preserve last known cart. */ }
              result.decision = recoveryDecision('add-outcome-unknown');
            }
            return result;
          }
        } else {
          body.id = action.lineKey; body.quantity = action.quantity;
          response = await post('change', body);
        }
        result.mutated = true;
        unpublishedMutation = true;
        renderDirty = true;
        latestSections = response.sections;
        if (!latestSections || sectionIds.some(function (id) { return latestSections[id] === null; })) needsRepair = true;
        await fresh();
        if (action.type === 'REMOVE' && attributes().apella_shagun_pending_add && !core.analyze(snapshot.cart, snapshot.config).gifts.length) {
          await persist({ apella_shagun_pending_add: '' }, result);
        }
      }
    } catch (_) {
      requestFailed = true;
      result.decision = recoveryDecision('refresh-failed');
    } finally {
      // Section rendering failures never enter the mutation loop or repeat ADD.
      if (current(gen) && (result.mutated || renderDirty)) {
        if (latestSections) {
          if (renderSections(latestSections, snapshot && snapshot.cart)) renderDirty = false;
          else needsRepair = true;
        } else if (renderDirty) needsRepair = true;
        if (needsRepair) {
          try {
            var repaired = await request(root + 'cart?sections=' + sectionIds.join(',') + '&_shagun=' + Date.now());
            if (current(gen) && renderSections(repaired, snapshot && snapshot.cart)) renderDirty = false;
          } catch (_) { /* State remains conservative; next lifecycle repairs UI. */ }
        }
      }
    }
    return result;
  }
  function notifyMutation(result) {
    if (!unpublishedMutation || !current(result.gen)) return;
    unpublishedMutation = false;
    try { window.localStorage.setItem(storageKey, JSON.stringify({ at: Date.now(), revision: queue.revision() })); } catch (_) { /* Private browsing. */ }
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shagun', cartData: snapshot && snapshot.cart })).catch(function () {});
    }
  }
  function reconcile(reason) {
    if (destroyed) return Promise.resolve(state);
    generation += 1;
    emit({ busy: true, celebrate: false });
    if (!drain) {
      var handled;
      drain = Promise.resolve().then(async function () {
        do {
          handled = generation;
          var work = function () {
            if (window.navigator && window.navigator.locks && typeof window.navigator.locks.request === 'function') {
              return window.navigator.locks.request('apella-shagun-native-cart', { mode: 'exclusive' }, function () { return transaction(handled); });
            }
            return transaction(handled);
          };
          var result;
          try { result = queue ? await queue.enqueue(work, 'shagun:' + (reason || 'reconcile')) : await work(); }
          catch (_) { result = { gen: handled, decision: recoveryDecision('refresh-failed'), mutated: false }; requestFailed = true; }
          if (current(handled) && result.decision) {
            var next = snapshot ? resultState(result.decision, false) : { status: 'NEEDS_RECOVERY', reason: 'refresh-failed', busy: false, celebrate: false };
            if (next.status === 'CONFIRMED' && !celebrated) {
              var celebrationKey = 'apella-shagun-celebrated:' + snapshot.config.campaignId;
              try { celebrated = window.sessionStorage.getItem(celebrationKey) === '1'; } catch (_) { /* Storage optional. */ }
              next.celebrate = !celebrated; celebrated = true;
              try { window.sessionStorage.setItem(celebrationKey, '1'); } catch (_) { /* Storage optional. */ }
            }
            emit(next);
            notifyMutation(result);
          }
        } while (!destroyed && handled !== generation);
        return state;
      }).finally(function () {
        drain = null;
        // A lifecycle microtask can arrive after the final loop check but
        // before this promise settles. Keep those callers on the fresh drain.
        if (!destroyed && handled !== generation) return reconcile('pending');
        if (!destroyed && state.busy) emit({ busy: false });
      });
    }
    return drain;
  }
  function setOptOut(value) {
    pendingPreferences.apella_shagun_opt_out = value ? '1' : '';
    if (!value) { pendingPreferences.apella_shagun_recovery = ''; pendingPreferences.apella_shagun_pending_add = ''; }
    return reconcile(value ? 'decline' : 'restore');
  }
  async function prepareCheckout() {
    for (var attempts = 0; attempts < 3; attempts += 1) {
      if (queue) await queue.whenIdle();
      await reconcile('checkout');
      var settledRevision = queue ? queue.revision() : 0;
      if (queue) await queue.whenIdle();
      if (drain) await drain;
      if (!queue || settledRevision === queue.revision()) break;
    }
    var analysis = snapshot && core ? core.analyze(snapshot.cart, snapshot.config) : null;
    var managed = analysis && analysis.gifts.length;
    var uncertainAdd = !!attributes().apella_shagun_pending_add;
    var ready = !uncertainAdd && (!managed || (!requestFailed && state.status === 'CONFIRMED' && managed === 1 && !!analysis.confirmedGift));
    return { ready: ready, reason: ready ? 'ready' : 'gift-needs-recovery' };
  }
  function isManagedLine(line) {
    return !!(snapshot && core && core.analyze(Object.assign({}, snapshot.cart, { items: [line] }), snapshot.config).gifts.length);
  }
  function listen(target, name, fn, options) {
    target.addEventListener(name, fn, options);
    cleanup.push(function () { target.removeEventListener(name, fn, options); });
  }
  function lifecycle(event) {
    if (event.type === 'visibilitychange' && document.visibilityState !== 'visible') return;
    if (event.type === 'storage' && event.key !== storageKey) return;
    if (event.detail && String(event.detail.source || '').indexOf('shagun') === 0) return;
    reconcile(event.type);
  }
  window.ApellaShagun = Object.freeze({ reconcile: reconcile, setOptOut: setOptOut, prepareCheckout: prepareCheckout, isManagedLine: isManagedLine,
    subscribe: function (fn) { listeners.add(fn); fn(state); return function () { listeners.delete(fn); }; },
    destroy: function () { destroyed = true; generation += 1; cleanup.forEach(function (fn) { fn(); }); listeners.clear(); }
  });
  try {
    var bootstrap = document.querySelector('[data-apella-gift-state]');
    if (bootstrap) { remember(JSON.parse(bootstrap.textContent)); if (core) emit(resultState(decide(), false)); }
  } catch (_) { /* Fresh endpoint is authoritative. */ }
  ['pageshow', 'popstate', 'online', 'storage', 'apella:cart-mutation', 'apella:cart-open'].forEach(function (name) { listen(window, name, lifecycle); });
  ['visibilitychange', 'apella:cart-mutation', 'apella:cart-open'].forEach(function (name) { listen(document, name, lifecycle); });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    cleanup.push(subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) { if (!event || String(event.source || '').indexOf('shagun') !== 0) reconcile('cart-update'); }));
  }
  listen(document, 'submit', function (event) {
    var submitter = event.submitter;
    var form = event.target;
    // Capture only the native checkout submitter; express payments stay native.
    if (!submitter || submitter.name !== 'checkout' || !form || form.tagName !== 'FORM') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    prepareCheckout().then(function (result) {
      if (!result.ready || destroyed) return;
      var input = document.createElement('input');
      input.type = 'hidden'; input.name = submitter.name; input.value = submitter.value || '';
      // Drawer section refresh can replace its form while checkout awaits the
      // queue. Submit the current form with the captured native submitter.
      var liveForm = (form.id && document.getElementById(form.id)) || form;
      liveForm.appendChild(input);
      // submit() avoids recursive requestSubmit interception while the hidden
      // input preserves Shopify's original checkout submitter semantics.
      HTMLFormElement.prototype.submit.call(liveForm);
      input.remove();
    }).catch(function () { emit({ busy: false, celebrate: false }); }).finally(function () { checkoutPending = false; });
  }, true);
  document.dispatchEvent(new CustomEvent('apella:gift-ready'));
  if (document.readyState === 'loading') listen(document, 'DOMContentLoaded', lifecycle, { once: true });
  else reconcile('initial');
})(window, document);
